<template>
  <div class="sticky top-0 bg-light-gray z-999">
    <div class="container">
      <div class="pa4 ph6-l">
        <autocomplete type="search" :placeholder="placeholder" @select="onSelect" inputClass="pa4 br-pill w-100 ba b--gray bw2" :items="items"></autocomplete>
      </div>
    </div>
  </div>
</template>

<script>

import Autocomplete from '../autocomplete/component.vue';

export default {
  components: { Autocomplete },
  name: 'connectorSearch',
  props: {
    placeholder: String,
    items: { type: Array, default: () => ([]) }
  },

  data () {
    const dataAttr = 'service';

    return {
      scrollOffset: 120,
      selector: `*[data-${dataAttr}]`,
      dataAttr,
      targets: [],
      highlightClasses: 'b--green bw2'
    };
  },

  methods: {
    onSelect (item = '') {
      this.targets.forEach($el => $el.classList.remove(...this.highlightClasses.split(' ')));
      const $match = this.targets.find($el => $el.dataset[this.dataAttr].toLowerCase() === item.toLowerCase());

      if ($match) {
        $match.classList.add(...this.highlightClasses.split(' '));

        const $container = $match.closest('details');
        if ($container) $container.setAttribute('open', true);
        const top = $match.offsetTop - this.scrollOffset;
        window.scrollTo({ top, behavior: 'smooth' });
      }
    }
  },

  mounted () {
    this.targets = Array.from(document.querySelectorAll(this.selector));
  }
};
</script>
